// import groundImgSrc from "./Images/土_草なし.png";
// import coinImgSrc from "./Images/コイン.png";
// import goalFlagImgSrc from "./Images/マイク.png";
// import cityImgSrc from "./Images/背景画像ビル.png";
// import moImgSrc from "./Images/山.png";
// import PEffectImgSrc from "./Images/ステージ画像.png";
// import NEffectImgSrc from "./Images/ステージ画像ミクのみ.png";
// import miku1ImgSrc from "./Images/miku1.png";
// import miku2ImgSrc from "./Images/miku2.png";
// import blockImgSrc from "./Images/block1.png";

function waitForTextAliveApp(callback) {
  if (window.TextAliveApp && window.TextAliveApp.Player) {
    callback();
  } else {
    setTimeout(() => waitForTextAliveApp(callback), 50);
  }
}

waitForTextAliveApp(() => {
  const Player = window.TextAliveApp.Player;


let taPlayer;       // TextAlive Player インスタンス
let gameStarted = false;   // ゲーム開始フラグ
let goalX = null; // ゴール旗のX座標
let coinOffset = 50;


//画像を読み込む
const groundImg = new Image();
groundImg.src = "/Images/土_草なし.png"; // 画像のパスを絶対パスに変更

const coinImg = new Image();
coinImg.src = "/Images/コイン.png"; // 画像のパスを絶対パスに変更

const goalFlagImg = new Image();
goalFlagImg.src = "/Images/マイク.png";

const cityImg = new Image();
cityImg.src = "/Images/昼間のビル.png";

const StracityImg = new Image();
StracityImg.src = "/Images/怪しいビル街.png";

const desrImg = new Image();
desrImg.src = "/Images/砂漠.png";

const blacityImg = new Image();
blacityImg.src = "/Images/夜ビル街.png";

const eveImg = new Image();
eveImg.src = "/Images/夕焼け.png";

const starImg = new Image();
starImg.src = "/Images/星空.png";

const moImg = new Image();
moImg.src = "/Images/晴れ山.png";

const bgImagesList = [
  moImg,
  StracityImg, // 怪しいビル街
  blacityImg, // 夜ビル街
  desrImg, // 砂漠
  eveImg, // 夕焼け
  starImg, // 星空
  cityImg, // 昼間のビル
];

const PEffectImg = new Image();
PEffectImg.src = "/Images/ステージ画像.png";

const NEffectImg = new Image();
NEffectImg.src = "/Images/ステージ画像ミクのみ.png";

const charaImgSrcs = [
  "/Images/miku1.png",
  "/Images/miku2.png",
];
const charaImgs = charaImgSrcs.map(src => {
  const img = new Image();
  img.src = src;
  return img;
});

const blockImg = new Image();
blockImg.src = "/Images/block1.png";

// 画像宣言の後に追加
function loadImage(img) {
  return new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = () => {
      console.error("画像の読み込みに失敗:", img.src);
      reject();
    };
  });
}

async function waitForAllImages() {
  try {
    await Promise.all([
      loadImage(groundImg),
      loadImage(coinImg),
      ...charaImgs.map(img => loadImage(img)),
      loadImage(goalFlagImg),
      loadImage(cityImg),
      loadImage(moImg),
      loadImage(PEffectImg),
      loadImage(NEffectImg),
      loadImage(blockImg)
    ]);
    // Webフォントの読み込みも待つ
    if (document.fonts && document.fonts.load) {
      // canvasで使うフォントサイズ・スタイルで明示的にロード
      await document.fonts.load("bold 60px 'Press Start 2P'");
      await document.fonts.load("bold 48px 'Press Start 2P'");
      await document.fonts.ready;
    }
    // ここでゲーム開始イベントを登録
    setupGame();
  } catch (e) {
    alert("画像の読み込みに失敗しました。ファイル名・パス・拡張子を再確認してください。");
  }
}

let lyrics = []; // 歌詞の配列　　グローバルで宣言

let score = 0; // スコアの初期化 グローバルで宣言


const startButton = document.getElementById("startButton"); // スタートボタンの取得
// キャンバスとコンテキストの取得
const canvas = document.getElementById("gameCanvas");
const ctx = canvas.getContext("2d");


//スクロール量（地面・背景の左方向移動）
let scrollX = 0;

class GamePlayer {
  constructor() { 
    // ゲームプレイヤーの初期化
    //this.x = canvas.width / 2; // 初期位置はキャンバスの中央
    this.x = 400; // 画面の左側に配置
    this.groundYPercent = 80; // 地面の高さをパーセンテージで指定（75% = 画面の3/4の位置）
    this.y = 0; // 初期値、後で updatePosition() で正しく設定
    this.vy = 0;
    this.gravity = 0.65;
    this.jumpStrength = -15;
    this.isOnGround = true; // 初期状態は地面にいる
    this.width = 128; // プレイヤーの幅
    this.height = 128; // プレイヤーの高さ

    this.frame = 0;
    this.frameCount = charaImgs.length;
    this.frameInterval = 4; // フレーム間隔
    this.frameTimer = 0;
  }

  // 地面のY座標を取得（パーセンテージから実際の座標に変換）
  getGroundY() {
    return (canvas.height * this.groundYPercent) / 100;
  }

  // キャラクターのY座標を更新（リサイズ時など）
  updatePosition() {
    if (this.isOnGround) {
      this.y = this.getGroundY() - this.height;
    }
  }

  // ゲームプレイヤーの更新
  // 重力の影響を受けて落下し、地面に衝突したら停止
  update(scrollSpeed = 7) {
    this.vy += this.gravity;
    this.y += this.vy;

    // 地面のY座標を取得
    const groundY = this.getGroundY();

    // 地面との衝突判定
    if (this.y >= groundY - this.height) {
      this.y = groundY - this.height;
      this.vy = 0;
      this.isOnGround = true;
    } else {
      this.isOnGround = false;
    }
    
    blocks.forEach(block => {
    if (checkPlayerBlockCollision(player, block)) {
      // 下から乗った場合のみ、上に乗る
      if (player.vy >= 0 && player.y + player.height - player.vy <= block.y) {
        player.y = block.y - player.height;
        player.vy = 0;
        player.isOnGround = true;
      }
      // 横や下からの衝突は必要に応じて追加
    }
    });

    if (!this.isOnGround) {
      this.frame = 0;
    } else {
      // ★ scrollSpeedに応じてアニメーション速度を調整
      this.frameTimer += scrollSpeed / 7; // 通常速度7のときは1ずつ進む
      if (this.frameTimer >= this.frameInterval) {
        this.frame = (this.frame + 1) % this.frameCount;
        this.frameTimer = 0;
      }
    }
  }

  // ジャンプ処理
  jump() {
    if (this.isOnGround) {
      this.vy = this.jumpStrength;
    }
  }

  // ゲームプレイヤーの描画
  draw(ctx) {
    // プレイヤーの描画
    ctx.drawImage(
      charaImgs[this.frame],
      this.x,         // X座標
      this.y,         // Y座標
      this.width,             // 幅（キャラのサイズに合わせて調整）
      this.height              // 高さ（キャラのサイズに合わせて調整）
    );

    const groundY = this.getGroundY();  // 地面のY座標をパーセンテージから取得
    const tileSize = 128;
    const tilesX = Math.ceil((canvas.width + scrollX) / tileSize);
    const tilesY = Math.ceil((canvas.height - groundY) / tileSize);

    
  for (let j = 0; j < tilesY; j++) {
    for (let i = 0; i < tilesX; i++) {
      ctx.drawImage(
        groundImg,
        i * tileSize - scrollX % tileSize,
        groundY + j * tileSize,
        tileSize,
        tileSize
      );
    }
  }
  }
}

class Block {
  constructor(x, y, width, height) {
    this.x = x; // ワールド座標
    this.y = y;
    this.width = width;
    this.height = height;
  }

  draw(ctx) {
    ctx.drawImage(
      blockImg,
      this.x - scrollX,
      this.y,
      this.width,
      this.height
    );
  }
}

const blocks = [
  new Block(700, canvas.height - 300, 128, 64), // 例
  // 必要に応じて追加
];

function checkPlayerBlockCollision(player, block) {
  // AABB衝突判定
  return (
    player.x < block.x + block.width &&
    player.x + player.width > block.x &&
    player.y < block.y + block.height &&
    player.y + player.height > block.y
  );
}



class LyricCoin {
  // 歌詞コインのコンストラクタ
  // text: 歌詞のテキスト, x: コインのx座標, yOffset: 地面からの高さ, startTime: 歌詞の開始時間
  // collected: コインが収集されたかどうか
  // startTime: 歌詞の開始時間
  constructor(text, x, yOffset, startTime) {
    this.text = text;
    this.x = x;
    this.yOffset = yOffset; // 地面からの高さ（固定値）
    this.collected = false;
    this.startTime = startTime;
    this.coinRadius = 30; // コインの半径
  }

  // コインのY座標を取得（地面の位置から計算）
  getY() {
    return player.getGroundY() - this.yOffset;
  }

  update(player) {
    // 簡易的な衝突判定（コインもスクロール分左に動く）
    // コインの画面上の座標
    const coinX = this.x - scrollX + coinOffset; // スクロール分左にずら
    const coinY = this.getY(); // 地面からの相対位置で計算

    //コインサイズ
    const coinRadius = this.coinRadius; // コイン
    if (
      !this.collected &&

      player.x < coinX + coinRadius &&
      player.x + player.width > coinX - coinRadius &&
      player.y < coinY + coinRadius &&
      player.y + player.height > coinY - coinRadius
    ) {
      this.collected = true;
      score += 100; //コイン取得時にスコアを100点加算する
      // ここで歌詞の再生やスコアの加算などを行う
    }
  }
  
  draw(ctx) {
    if (!this.collected) {
      const coinY = this.getY(); // 地面からの相対位置で計算
      
      ctx.drawImage(
        coinImg,
        this.x - scrollX - this.coinRadius + coinOffset, // スクロール分左にずらす
        coinY - this.coinRadius, // コインの中心をy座標に合わせるために半径を引く
        this.coinRadius * 2, // コインの直径
        this.coinRadius * 2 // コインの直径
      )

      ctx.font = "bold 25px DotGothic16";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(
        this.text, 
        this.x - scrollX + coinOffset,
        coinY);
    }
  }
}


// 変更したいタイミング（秒→ミリ秒）と色リスト
const gradChangeTimes = [5000, 20000, 37000, 53000, 90000, 102000, 144000]; // ms
const gradColorsList = [
  ["#aee1f9", "#aee1f9"],     
  ["#aee1f9", "#6a5acd"],  
  ["#6a5acd", "#2f2f4f"],     
  ["#2f2f4f", "#b0e0e6"],   
  ["#b0e0e6", "#ff6347"],  
  ["#ff6347", "#191970"], 
  ["#191970", "#aee1f9"], 
];
let currentGradIndex = 0;
let gradStartScrollX = null;

const player = new GamePlayer();
let isGoal = false; // ゴールフラグ

// 背景画像のクロスフェード処理
function drawBackgroundImageMain(ctx, scrollX, bgY, currentGradIndex, gradProgress) {
  const prevBgImg = bgImagesList[Math.max(0, currentGradIndex - 1)];
  const nextBgImg = bgImagesList[currentGradIndex];
  let fadeT = gradProgress; // 0～1で進行度
  if (currentGradIndex === 0) fadeT = 1; // 最初は完全にnextのみ

  // 地面のY座標を取得
  const groundY = player.getGroundY();
  // それぞれの画像の下端が地面に合うようにY座標を計算
  const prevBgY = prevBgImg ? groundY - prevBgImg.height : 0;
  const nextBgY = nextBgImg ? groundY - nextBgImg.height : 0;

  // 前の画像
  if (prevBgImg && fadeT < 1) {
    ctx.save();
    ctx.globalAlpha = 1 - fadeT;
    for (let x = -scrollX % prevBgImg.width; x < canvas.width; x += prevBgImg.width) {
      ctx.drawImage(prevBgImg, x, prevBgY);
    }
    ctx.restore();
  }
  // 新しい画像
  ctx.save();
  ctx.globalAlpha = fadeT;
  for (let x = -scrollX % nextBgImg.width; x < canvas.width; x += nextBgImg.width) {
    ctx.drawImage(nextBgImg, x, nextBgY);
  }
  ctx.restore();
}

function gameLoop() {
  // ★テスト用：すぐゴール演出を表示
  /*isGoal = true;
  // 必要ならscoreもテスト値に
  score = 70000; // パーフェクト演出を見たい場合など
  */

  // 現在の再生位置を取得
  let now = 0;
  if (taPlayer && typeof taPlayer.position === "number") {
    now = taPlayer.position;
  } else if (mainApp && typeof mainApp._position === "number") {
    now = mainApp._position;
  }

  // どの色セットを使うか判定
  let nextGradIndex = currentGradIndex;
  for (let i = gradChangeTimes.length - 1; i >= 0; i--) {
    if (now >= gradChangeTimes[i]) {
      //console.log(now, gradChangeTimes[i], i);
      nextGradIndex = i;
      break;
    }
  }
  // まずインデックスを更新
  if (nextGradIndex !== currentGradIndex) {
    currentGradIndex = nextGradIndex;
    gradStartScrollX = scrollX; // 色セットが切り替わったタイミングでリセット
  }
  // 初回のみnull対策
  if (gradStartScrollX === null) {
    gradStartScrollX = scrollX;
  }

  const gradColors = gradColorsList[currentGradIndex];
  const gradLength = canvas.width * 1.5;
  let gradProgress = 0;
  if (currentGradIndex === 0) {
    gradProgress = 0;
  } else {
    gradProgress = Math.min((scrollX - gradStartScrollX) / gradLength, 1);
  }

  // グラデーション区間計算
  let section = 0;
  let sectionT = 0;
  const sectionCount = gradColors.length - 1;

  for (let i = 0; i < sectionCount; i++) {
    const start = i / sectionCount;
    const end = (i + 1) / sectionCount;
    if (gradProgress <= end || i === sectionCount - 1) {
      section = i;
      sectionT = (gradProgress - start) / (end - start);
      sectionT = Math.max(0, Math.min(1, sectionT));
      break;
    }
  }


    if (currentGradIndex === 0 && gradProgress === 0) {
    // 最初の区間は全面を最初の色で塗る
    ctx.fillStyle = gradColors[0];
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  } else if (gradProgress >= 1) {
    ctx.fillStyle = gradColors[gradColors.length - 1];
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  } else {
    const grad = ctx.createLinearGradient(0, 0, canvas.width, 0);
    const blendWidth = 300; // px

    const borderPx = canvas.width * (1 - gradProgress);
    const borderCenter = borderPx / canvas.width;
    const halfBlend = blendWidth / 2 / canvas.width;
    const borderStart = Math.max(0, Math.min(1, borderCenter - halfBlend));
    const borderEnd = Math.max(0, Math.min(1, borderCenter + halfBlend));

    const colorStart = gradColors[section];
    const colorEnd = gradColors[section + 1] || colorStart;

    grad.addColorStop(0, colorStart);
    grad.addColorStop(borderStart, colorStart);
    grad.addColorStop(borderEnd, colorEnd);
    grad.addColorStop(1, colorEnd);

    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  // gameLoop内で
  // 背景画像の描画
    const groundY = player.getGroundY();
    const bgImg = bgImagesList[currentGradIndex];
    const bgY = groundY - bgImg.height;
    // ★クロスフェードで背景画像を描画
    drawBackgroundImageMain(ctx, scrollX, bgY, currentGradIndex, gradProgress);


  if (isGoal) {
    ctx.save();
    // ゴール演出用の背景色（例：淡いシアン系グラデーション）
    const grad = ctx.createLinearGradient(0, 0, 0, canvas.height);
    grad.addColorStop(0, "#e0f7fa");
    grad.addColorStop(1, "#b2ebf2");
    ctx.globalAlpha = 1.0;
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // スコアによる演出分岐
    let message = "GOAL！";
    let color = "black";
    let effectImg = null;

    if (score >= 68900) {
      message = "PERFECT！";
      color = "#ff9800";
      effectImg = PEffectImg; // パーフェクト用画像
    } else {
      message = "GOAL！";
      color = "black";
      effectImg = NEffectImg; // 通常用画像
    }

    // ★画像を中央に表示
    if (effectImg && effectImg.complete) {
      const imgW = 1024;
      const imgH = 512;
      ctx.drawImage(
        effectImg,
        (canvas.width - imgW) / 2 - 20,
        (canvas.height - imgH) / 2 - 20,
        imgW,
        imgH
      );
    }

    ctx.font = "bold 60px 'Press Start 2P', 'DotGothic16', sans-serif";
    ctx.fillStyle = color;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    // コメント（message）を中央から80px下に表示
    ctx.fillText(message, canvas.width / 2, canvas.height / 2 - 40);
    ctx.font = "bold 48px 'Press Start 2P', 'DotGothic16', sans-serif";
    ctx.fillStyle = "black";
    // スコアを中央から120px上に表示
    ctx.fillText(`SCORE: ${score}`, canvas.width / 2, canvas.height / 2 - 220);
    ctx.restore();

    // ★ここでボタンを表示
    const backBtn = document.getElementById("backToTitleButton");
    if (backBtn) backBtn.style.display = "block";

    return; // ここでループ終了
  }
  if (!gameStarted) return;


  //スコア表示
  ctx.font = "28px 'Press Start 2P', 'DotGothic16', sans-serif";
  ctx.fillStyle = "black";
  ctx.textAlign = "left";
  ctx.textBaseline = "top";
  ctx.fillText(`SCORE: ${score}`, 20, 20);

  //ゴール旗の描画
  if (goalX !== null) {
    ctx.save();
    // ゴール旗画像があれば画像で描画
    if (goalFlagImg && goalFlagImg.complete) {
      const flagWidth = 128;  // 画像の幅
      const flagHeight = 128; // 画像の高さ
      ctx.drawImage(
        goalFlagImg,
        goalX - scrollX - flagWidth / 2,
        canvas.height - 200 - flagHeight,
        flagWidth,
        flagHeight
      );
    } else {
      // 画像がまだ読み込まれていない場合は簡易的な旗を描画
      ctx.fillStyle = "red";
      ctx.fillRect(goalX - scrollX, canvas.height - 200, 10, 80); // ポール
      ctx.beginPath();
      ctx.moveTo(goalX - scrollX + 10, canvas.height - 200);
      ctx.lineTo(goalX - scrollX + 50, canvas.height - 180);
      ctx.lineTo(goalX - scrollX + 10, canvas.height - 160);
      ctx.closePath();
      ctx.fillStyle = "yellow";
      ctx.fill();
    }
    ctx.restore();

    // ゴール判定
    if (!isGoal && player.x > goalX - scrollX) {
      isGoal = true;
      gameStarted = false; // ゴールしたらゲームを停止
      gameLoop(); // ゴール演出描画
      return; // ゴール後はループ停止
    }
  }

  // スクロール量を更新
  let currentSpeed = 7;
  if (!isGoal) {
    if (goalX === null) {
      scrollX += 7;
      currentSpeed = 7;
    } else {
      scrollX += 4;
      currentSpeed = 4;
    }
  }
  player.update(currentSpeed);
  player.draw(ctx);

  if (mainApp._gameCoins) {
    mainApp._gameCoins
      .slice()
      .sort((a, b) => b.startTime - a.startTime)
      .forEach((coin) => {
        coin.update(player);
        coin.draw(ctx);
      });
  }

  requestAnimationFrame(gameLoop);
}


const backBtn = document.getElementById("backToTitleButton");
if (backBtn) {
  backBtn.onclick = () => {
    // ページをリロードして最初の状態に戻す
    location.reload();
    // または、必要に応じて初期化処理を呼ぶ
  };
}

function setupGame() {
  startButton.addEventListener("click", async () => {
    if (gameStarted) return;
    gameStarted = true;
    startButton.style.display = "none";
    canvas.style.display = "block";

    const settingButton = document.getElementById("settingButton");
    if (settingButton) {
      settingButton.style.display = "none";
    }
    
    // ロゴを非表示にする
    const gameLogo = document.getElementById("gameLogo");
    if (gameLogo) {
      gameLogo.style.display = "none";
    }
    
    // キャンバスのサイズをウィンドウに合わせる
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // キャラクターの位置を正しく設定
    player.updatePosition();

    // 1) TextAlive を再生
    if (taPlayer) {
      await taPlayer.requestPlay();
    }

    // 2) ゲームループを開始
    if (mainApp._gameCoins) {
      lyrics = mainApp._gameCoins; // 歌詞コインを取得
    }

    gameLoop();

    document.addEventListener("keydown", (e) => {
      if (e.code === "Space") {
        player.jump();
      }
    });
  });

  //リサイズに対応
  window.addEventListener("resize", () => {
    if (canvas.style.display === "block") {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      // キャラクターの位置を更新
      player.updatePosition();
    }
  });
}


document.addEventListener("visibilitychange", () => {
  if (!taPlayer || !taPlayer.video) return;
  if (document.hidden) {
    // タブが非アクティブになったら曲を一時停止
    taPlayer.requestPause();
  } else {
    // タブがアクティブになったら曲を再開
    if (gameStarted) {
      taPlayer.requestPlay();
    }
  }
});


class Main
{
    constructor ()
    {
        this._initPlayer();
        window.addEventListener("resize", () => this._resize());
        //this._update();
    }

    // プレイヤー初期化
    _initPlayer() 
    {

        taPlayer = new Player({
        app: { token: "11rguNN5DI7sLV9b" }, // ここに TextAlive API のトークンを入力
        mediaElement: document.querySelector("#media"),
        vocalAmplitudeEnabled: true // ボカロの音量を取得する
        });

        //ループ無効化
        const media = document.querySelector("#media");
        if (media) media.loop = false;
        
        taPlayer.addListener({
        onAppReady: (app) => this._onAppReady(app),
        onVideoReady: (v) => this._onVideoReady(v),
        onTimeUpdate: (pos) => this._onTimeUpdate(pos),
        onPlayEnd:() => this.onPlayEnd()
        });
        this._player = taPlayer;

    }
    // アプリ準備完了
    _onAppReady (app)
    {
        if (! app.songUrl)
        {
            this._player.createFromSongUrl("https://piapro.jp/t/ULcJ/20250205120202", {
                video: {
                    // 音楽地図訂正履歴
                    beatId: 4694275,
                    chordId: 2830730,
                    repetitiveSegmentId: 2946478,
      
                    // 歌詞URL: https://piapro.jp/t/DPXV
                    // 歌詞タイミング訂正履歴: https://textalive.jp/lyrics/piapro.jp%2Ft%2FULcJ%2F20250205120202
                    lyricId: 67810,
                    lyricDiffId: 20654
                },
            });
        }

    }
  
      _onVideoReady(v) 
    {
    // 歌詞のセットアップ
    var lyrics = [];
    if (v.firstChar) {
      var c = v.firstChar;
      while (c) {
        lyrics.push(new Lyric(c));
        c = c.next;
      }
    }

    //ローディング画面消す
    const loadingScreen = document.getElementById("loadingScreen");
    if (loadingScreen) {
      setTimeout(() => {
        loadingScreen.style.display = "none";
      }, 2000); // 1.5秒(1500ms)遅延
    }


    
    // キャラのジャンプ最高到達点を計算
    const jumpHeight = 200; // 例: ジャンプで届く高さ(px)（必要に応じて調整）

    const scrollSpeed = 7;
    const playerX = player.x;

    const coins = lyrics.map((lyric, index) => {
      const t = lyric.startTime;
      const x = playerX + scrollSpeed * (t / 16.67) + 100;

      // --- アーチ状に配置 ---
      // 例: 10個ごとにアーチを描く
      const archLength = 10; // アーチの長さ（コイン数）
      let yOffset = 70; // デフォルト高さ

      if (Math.floor(index / archLength) % 2 === 1) {
        // アーチ区間
        const archPos = index % archLength;
        // サインカーブでアーチを作る（0～π）
        const theta = Math.PI * (archPos / (archLength - 1));
        yOffset = 70 + Math.sin(theta) * jumpHeight; // 70px上～(70+jumpHeight)px上
      }

      return new LyricCoin(lyric.text, x, yOffset, lyric.startTime);
    });

    this._gameCoins = coins;
  }
 
    // 再生位置アップデート
    _onTimeUpdate (position)
    {
        this._position   = position;
        this._updateTime = Date.now();

        if (
          this._player &&
          this._player.video &&
          position >= this._player.video.duration - 7000 && // 残り100ms以内
          goalX === null
        ) {
          goalX = scrollX + canvas.width - 200;
          gameStarted = true;
          gameLoop();
        }
    }

    _update ()
    {
      this._position = position;
      this._updateTime = Date.now();
    }
    _resize ()
    {
        //必要ならcanvasのサイズを変更
        canvas.width  = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    onPlayEnd(){
      console.log("再生終了");
      if (goalX === null) {
        // ゴール旗の位置を設定
        goalX = scrollX + canvas.width - 200; // プレイヤーの位置から600px右にゴール旗を配置
        gameStarted = true;     // ループを再開
        gameLoop();             // ループを再開
      }
    }
}

const mainApp = new Main();



class Lyric
{
    constructor (data)
    {
        this.text      = data.text;      // 歌詞文字
        this.startTime = data.startTime; // 開始タイム [ms]
        this.endTime   = data.endTime;   // 終了タイム [ms]
        this.duration  = data.duration;  // 開始から終了迄の時間 [ms]
        
        this.x = 0; // グリッドの座標 x
        this.y = 0; // グリッドの座標 y
        this.isDraw = false; // 描画するかどうか
    }
}

waitForAllImages();

document.getElementById("settingButton").onclick = function() {
  document.getElementById("howToPlayModal").style.display = "block";
};
document.getElementById("closeModal").onclick = function() {
  document.getElementById("howToPlayModal").style.display = "none";
};
// モーダル外クリックで閉じる
window.onclick = function(event) {
  const modal = document.getElementById("howToPlayModal");
  if (event.target === modal) {
    modal.style.display = "none";
  }
};
});